import { useEffect } from 'react';

const HubspotScript = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js-na2.hs-scripts.com/242510258.js';
    script.async = true;
    script.defer = true;
    script.id = 'hs-script-loader';

    document.body.appendChild(script);

    return () => {
      // Optional cleanup if script needs to be removed on unmount
      const existingScript = document.getElementById('hs-script-loader');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return null;
};

export default HubspotScript;
